<div class="max-page-width">
  <div class="my-bookings">
    <h1>{{ 'MyBookings' | translate  }}</h1>
    <div *ngIf="thierIsBokking">

      <mat-tab-group class="booking-details" animationDuration="0ms" (selectedTabChange)="tabChanged($event)">

        <!--Confirmed-->
        <mat-tab   label="{{ 'Confirmed' | translate }}">

        </mat-tab>


        <!--Pickedup-->
        <mat-tab label="{{ 'Pickedup' | translate }}">

        </mat-tab>

        <!--Returned-->
        <mat-tab label="{{ 'Returned' | translate }}">

        </mat-tab>

      </mat-tab-group>


      <div
      class=""
      infiniteScroll [infiniteScrollDistance]="5" [infiniteScrollThrottle]="30"
      [scrollWindow]="true"  (scrolled)="onScroll()"
      *ngFor="let vehicle of myBookingsFilter; let i = index"

      >
        <!-- Start Card  -->
        <div class="cardVehicle">

          <!-- Make-Model-Year -->
          <div *ngIf="vehicle.MMYType">
            <div class="row">
              <div class="col-lg-2 col-md-3 text-center">
                  <div class="car-image">
                    <img class="img-fluid" [src]="attachmentService
                    .getMMYCarImageLink(vehicle.modelID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.MMYImage,vehicle.makeId,vehicle.modelId,vehicle.year)" [alt]="vehicle.vehicleName" >
                  </div>
                  <ng-container *ngIf=" vehicle.vehicleReservationStateID !=vehicleReservationState.Cancelled" >
                  <button class="btnLink" (click)="openReviewDialog(vehicle)" *ngIf="vehicle.evaluationSummary!=null &&vehicle.evaluationSummary.evaluationLogsDetails.length>0">
                    <div class="car-details d-flex">
                      <div class="car-rank"><span class="badge badge-pill badge-primary">
                          <!--{{vehicle.vehicleRankNumber}}-->{{vehicle.evaluationSummary.average}}</span>
                        <!--{{vehicle.vehicleRankText}}--> {{vehicle.evaluationSummary.resourceName}}</div>
                      <div class="car-reviews ml-1"> ({{vehicle.evaluationSummary.countEvaluation}}) {{ 'Reviews' | translate }}
                      </div>
                    </div>
                  </button>
                </ng-container>
              </div>
              <div class="col-lg-8 col-md-6 border-right">
                <div class="d-flex">
                  <div class="vehicle-name mr-auto">
                      {{vehicle.vehicleName}}
                    </div>
                    <div class="vehicle-top-list  d-flex align-items-top">
                      <div class="vehicle-class">
                        {{vehicle.vehicleClass}}
                      </div>
                    </div>
                </div>
                <div class="vehicle-features">
                  <div class="row">
                    <div class="col-lg-8 col-md-12">
                      <div class="row mt-2">
                        <!-- vehicle Gear Type-->
                        <div class="col-lg-3 col-md-4 col-6 d-flex  align-items-top">
                          <span> <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' /></span>
                          <div>
                            <ul *ngFor="let gearType of vehicle.vehicleGearTypeList" class="vehicle-inner-list">
                              <li>{{gearType}}</li>
                            </ul>
                          </div>
                        </div>

                        <!-- vehicle Condition Unit
                        <div class="col-lg-3 col-md-4 d-flex align-items-top">
                          <span><mat-icon placement="bottom" ngbPopover="{{ 'ACUnit' | translate }}" triggers="mouseenter:mouseleave" class="fa-s  mr-1">ac_unit</mat-icon></span>
                          <div>
                            <ul *ngFor="let conditionUnit of vehicle.vehicleConditionUnit" class="vehicle-inner-list">
                              <li>{{conditionUnit}}</li>
                            </ul>
                          </div>
                        </div> -->

                        <!-- vehicle Petrol Type -->
                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <span><fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'FuelType' | translate }}" triggers="mouseenter:mouseleave"  [icon]="faGasPump"></fa-icon></span>
                            <div>
                              <ul *ngFor="let petrolType of vehicle.vehiclePetrolTypeList" class="vehicle-inner-list">
                                <li>{{petrolType}}</li>
                              </ul>
                            </div>
                        </div>

                        <!-- vehicle Passengers Number -->
                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <span> <fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'PassengersNum' | translate }}" triggers="mouseenter:mouseleave" [icon]="faUser"></fa-icon></span>
                          <div>
                            <ul *ngFor="let passengersNumber of vehicle.vehiclePassengersNumberList" class="vehicle-inner-list">
                              <li>{{passengersNumber}}</li>
                            </ul>
                          </div>
                        </div>

                        <!-- vehicle Doors Number -->
                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <span> <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' />  </span>
                          <div>
                            <ul *ngFor="let doorsNumber of vehicle.vehicleDoorsNumberList" class="vehicle-inner-list">
                              <li>{{doorsNumber}}</li>
                            </ul>
                          </div>
                        </div>

                        <!-- vehicle Storage -->
                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <span><mat-icon placement="bottom" ngbPopover="{{ 'Luggage' | translate }}" triggers="mouseenter:mouseleave" class="fa-s luggage mr-1">luggage</mat-icon></span>
                          <div>
                            <ul *ngFor="let storage of vehicle.vehicleStorageList" class="vehicle-inner-list">
                              <li>{{storage}}</li>
                            </ul>
                          </div>
                        </div>

                      
                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <div class="car-colors  justify-content-center">
                            <div class="d-flex">
                              <div class="d-flex" style="float: left;" *ngFor="let color of vehicle.vehicleColors; let i = index">
                                <span *ngIf="i < 4">
                                  <span class="color-box mr-1" [style.backgroundColor]="color" ></span>
                                </span>
                              </div>
                              <div  *ngFor="let color of vehicle.vehicleColors; let i = index">
                                <span *ngIf="i == 4 && vehicle.vehicleColors.length > 4">
                                  <a class="" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample"><i class="far fa-plus-square color-expand"></i></a>
                                </span>
                              </div>
                            </div>
            
                            <div class="collapse" id="collapseExample">
                              <ul>
                                <li class="d-inline" *ngFor="let color of vehicle.vehicleColors; let i = index">
            
                                  <div *ngIf="i > 4">
                                    <span class="color-box mr-1" [style.backgroundColor]="color" ></span>
                                  </div>
                              
                                </li>
                              </ul>
                            </div>
                          
                          </div>
                        </div>

                      </div>
                      <div class="row mb-2 mt-2">
                        <div class="col-md-12 d-flex align-items-top"><fa-icon placement="bottom" ngbPopover="{{ 'Location' | translate }}" triggers="mouseenter:mouseleave" class="mr-1 fa-s" [icon]="faMapMarkerAlt"></fa-icon>{{ 'From' | translate }}: {{vehicle.agencyName | translate}} - {{ 'To' | translate }}: {{vehicle.loationName | translate}}</div>
                        <div class="col-md-12"><div class="veheicle-status-confirmed">{{vehicle.vehicleBookingStatus}}</div></div>
                      </div>
                      <policies-icons [policyRequestModel]="vehicle"></policies-icons>
                    </div>
                    <div class="col-lg-4 col-md-12 pr-lg-0" *ngIf="vehicle.showCountDown">
                      <div   class="countdown wow pulse animated" *ngIf="!vehicle.late">
                        <div  class="countdown-title">{{ 'YourTripStartsIn' | translate }}</div>
                        <p [id]="'countdown_'+vehicle.caseID">
                          <span class="days" [id]="vehicle.caseID+'_days'"></span> <span class="time-sep"> : </span>
                          <span class="hours" [id]="vehicle.caseID+'_hours'"></span> <span class="time-sep"> : </span>
                          <span class="minutes" [id]="vehicle.caseID+'_minutes'"> </span> <span class="time-sep"> : </span>
                          <span class="seconds" [id]="vehicle.caseID+'_seconds'"></span>
                        </p>
                      </div>
                      <div *ngIf="vehicle.late">
                        <div   class="countdown wow pulse animated">
                          <div class="countdown-title"> {{ 'YouareLate' | translate }}</div>
                          <div class="late-duration">{{vehicle.startDateString}} {{vehicle.startTimeString}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-3 d-flex align-items-center justify-content-center">

                <div class="justify-content-center">
                  <div class="price-container">
                      <div class="duration">{{ 'PriceFor' | translate }} {{vehicle.durationUnitName}}</div>
                    <div class="vehicle-price">{{vehicle.vehiclePrice | number : '1.2-2'}} {{currency}}</div>
                  </div>
                  <div class="payable-now">
                {{ 'OutstandingBalance' | translate }}
                    <!-- <span class="">{{vehicle.grandTotal - math.abs(vehicle.outStandingBalance) | number : '1.2-2'}} {{currency}}</span> -->
                    <span class="">{{vehicle.outStandingBalance | number : '1.2-2'}} {{currency}}</span>
                  </div>
                  <div class="book-now">
                    <button (click)="viewBooking(vehicle)" class="btn btn-book-now" mat-button>{{vehicle.vehicleBookingNumber}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Make-Model-Year -->

          <!-- Class -->
          <div *ngIf="vehicle.classType">
            <div class="row">
              <div class="col-lg-2 col-md-3 text-center">
                  <div class="car-image">
                    <img class="img-fluid" [src]="attachmentService
                    .getImageLink(vehicle.classID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.VehicleClassImg)" [alt]="vehicle.vehicleName" >
                  </div>
                  <ng-container *ngIf=" vehicle.vehicleReservationStateID !=vehicleReservationState.Cancelled" >
                    <button class="btnLink" (click)="openReviewDialog(vehicle)" *ngIf="vehicle.evaluationSummary!=null &&vehicle.evaluationSummary.evaluationLogsDetails.length>0">
                      <div class="car-details d-flex ">
                        <div class="car-rank"><span class="badge badge-pill badge-primary">
                            <!--{{vehicle.vehicleRankNumber}}-->{{vehicle.evaluationSummary.average}}</span>
                          <!--{{vehicle.vehicleRankText}}--> {{vehicle.evaluationSummary.resourceName}}</div>
                        <div class="car-reviews ml-1"> ({{vehicle.evaluationSummary.countEvaluation}}) {{ 'Reviews' | translate }}
                        </div>
                      </div>
                    </button>
                  </ng-container>

              </div>
              <div class="col-lg-8 col-md-6 border-right">
              <!--    <div class="d-flex">
                  <div class="vehicle-name mr-auto">
                    <span>{{vehicle.vehicleName}} Dacia Logan 2020 </span><small> or similar</small>
                  </div>
                <div class="vehicle-top-list  d-flex align-items-top">
                    <fa-icon class="mr-1 grey" [icon]="faKey"></fa-icon><span>({{vehicle.vehicleRentalNumber}})</span>
                  </div>
                </div>-->
                <div class="vehicle-class" >
                  {{vehicle.vehicleClass}}
                </div>
                <div class="vehicle-features">
                  <div class="row">
                    <div class="col-lg-8 col-md-12">
                      <div class="row mt-2">
                        <!-- vehicle Gear Type-->
                        <div class="col-lg-3 col-md-4 col-6 d-flex  align-items-top">
                          <span> <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' /></span>
                          <div>
                            <ul *ngFor="let gearType of vehicle.vehicleGearTypeList" class="vehicle-inner-list">
                              <li>{{gearType}}</li>
                            </ul>
                          </div>
                        </div>

                        <!-- vehicle Condition Unit
                        <div class="col-lg-3 col-md-4 d-flex align-items-top">
                          <span><mat-icon placement="bottom" ngbPopover="{{ 'ACUnit' | translate }}" triggers="mouseenter:mouseleave" class="fa-s  mr-1">ac_unit</mat-icon></span>
                          <div>
                            <ul *ngFor="let conditionUnit of vehicle.vehicleConditionUnit" class="vehicle-inner-list">
                              <li>{{conditionUnit}}</li>
                            </ul>
                          </div>
                        </div>  -->

                        <!-- vehicle Petrol Type -->
                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <span><fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'FuelType' | translate }}" triggers="mouseenter:mouseleave"  [icon]="faGasPump"></fa-icon></span>
                            <div>
                              <ul *ngFor="let petrolType of vehicle.vehiclePetrolTypeList" class="vehicle-inner-list">
                                <li>{{petrolType}}</li>
                              </ul>
                            </div>
                        </div>

                        <!-- vehicle Passengers Number -->
                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <span> <fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'PassengersNum' | translate }}" triggers="mouseenter:mouseleave" [icon]="faUser"></fa-icon></span>
                          <div>
                            <ul *ngFor="let passengersNumber of vehicle.vehiclePassengersNumberList" class="vehicle-inner-list">
                              <li>{{passengersNumber}}</li>
                            </ul>
                          </div>
                        </div>

                        <!-- vehicle Doors Number -->
                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <span> <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' /> </span>
                          <div>
                            <ul *ngFor="let doorsNumber of vehicle.vehicleDoorsNumberList" class="vehicle-inner-list">
                              <li>{{doorsNumber}}</li>
                            </ul>
                          </div>
                        </div>

                        <!-- vehicle Storage -->
                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <span><mat-icon placement="bottom" ngbPopover="{{ 'Luggage' | translate }}" triggers="mouseenter:mouseleave" class="fa-s luggage mr-1">luggage</mat-icon></span>
                          <div>
                            <ul *ngFor="let storage of vehicle.vehicleStorageList" class="vehicle-inner-list">
                              <li>{{storage}}</li>
                            </ul>
                          </div>
                        </div>
                        <!-- <div class="col-lg-3 col-md-4 d-flex align-items-top">
                          <div class="car-colors d-flex justify-content-center">
                            <ul>
                              <li class="d-inline" *ngFor="let color of vehicle.vehicleColors">
                                <div class="color-box mr-1" [style.backgroundColor]="color" ></div>
                              </li>
                            </ul>
                          </div>
                        </div> -->

                      </div>
                      <div class="row mb-2 mt-2">
                        <div class="col-md-12 d-flex align-items-top"><fa-icon class="mr-1 fa-s" [icon]="faMapMarkerAlt"></fa-icon>{{ 'From:' | translate }} {{vehicle.agencyName | translate}} - {{ 'To:' | translate }} {{vehicle.vehicleLocation | translate}}</div>
                        <div class="col-md-12"><div class="veheicle-status-confirmed">{{vehicle.vehicleBookingStatus}}</div></div>
                      </div>
                      <policies-icons [policyRequestModel]="vehicle"></policies-icons>
                    </div>
    <!--                <div class="col-md-5 pr-0">
                      <div *ngIf="vehicle.showCountDown&&vehicle.countDownInSec>0"  class="countdown" >
                        <div  class="countdown-title">Your Trip Starts In</div>
                        <countdown #countdown  [config]="{leftTime: vehicle.countDownInSec,format:'d hh:mm:ss'}" (finished)="finishTest()">$!h!:$!m!:$!s!</countdown>
                      </div>
                    </div> -->
                    <div class="col-lg-4 col-md-12 pr-lg-0" *ngIf="vehicle.showCountDown">
                      <div   class="countdown wow pulse animated" *ngIf="!vehicle.late">
                        <div  class="countdown-title">{{ 'YourTripStartsIn' | translate }}</div>
                        <p [id]="'countdown_'+vehicle.caseID">
                          <span class="days" [id]="vehicle.caseID+'_days'"></span> <span class="time-sep"> : </span>
                          <span class="hours" [id]="vehicle.caseID+'_hours'"></span> <span class="time-sep"> : </span>
                          <span class="minutes" [id]="vehicle.caseID+'_minutes'"> </span> <span class="time-sep"> : </span>
                          <span class="seconds" [id]="vehicle.caseID+'_seconds'"></span>
                        </p>
                      </div>
                      <div *ngIf="vehicle.late">
                        <div   class="countdown wow pulse animated">
                          <div class="countdown-title"> {{ 'YouareLate' | translate }}</div>
                          <div class="late-duration">{{vehicle.startDateString}} {{vehicle.startTimeString}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-3 d-flex align-items-center justify-content-center">

                <div class="justify-content-center">
                  <div class="price-container">
                      <div class="duration">{{ 'PriceFor' | translate }} {{vehicle.durationUnitName}}</div>
                    <div class="vehicle-price">{{vehicle.vehiclePrice | number : '1.2-2'}} {{currency}}</div>
                  </div>
                  <div class="payable-now">
                  {{ 'OutstandingBalance' | translate }}
                    <!-- <span class="">{{vehicle.grandTotal - math.abs(vehicle.outStandingBalance) | number : '1.2-2'}} {{currency}}</span> -->
                    <span class="">{{vehicle.outStandingBalance | number : '1.2-2'}} {{currency}}</span>
                  </div>
                  <div class="book-now">
                    <button (click)="viewBooking(vehicle)" class="btn btn-book-now" mat-button>{{vehicle.vehicleBookingNumber}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Class -->

          <!-- vehicle -->
          <div *ngIf="vehicle.vehicleType">
            <div class="row">
              <div class="col-lg-2 col-md-3 text-center">
                  <div class="car-image">
                    <img class="img-fluid" [src]="attachmentService
                    .getImageLink(vehicle.vehicleID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.CarImage)"  [alt]="vehicle.vehicleName" >
                  </div>
                  <ng-container *ngIf=" vehicle.vehicleReservationStateID !=vehicleReservationState.Cancelled" >
                  <button class="btnLink" (click)="openReviewDialog(vehicle)" *ngIf="vehicle.evaluationSummary!=null &&vehicle.evaluationSummary.evaluationLogsDetails.length>0">
                    <div class="car-details d-flex">
                      <div class="car-rank"><span class="badge badge-pill badge-primary">
                          <!--{{vehicle.vehicleRankNumber}}-->{{vehicle.evaluationSummary.average}}</span>
                        <!--{{vehicle.vehicleRankText}}--> {{vehicle.evaluationSummary.resourceName}}</div>
                      <div class="car-reviews ml-1"> ({{vehicle.evaluationSummary.countEvaluation}}) {{ 'Reviews' | translate }}
                      </div>
                    </div>
                  </button>
                </ng-container>
              </div>
              <div class="col-lg-8 col-md-6 border-right">
                <div class="d-flex">
                  <div class="vehicle-name mr-auto">
                      {{vehicle.vehicleName}}
                    </div>
                    <div class="vehicle-top-list  d-flex align-items-top">
                      <div class="vehicle-class">
                        {{vehicle.vehicleClass}}
                      </div>
                      <!--               <div class="vehicle-top-list  d-flex align-items-top">
                    <fa-icon class="mr-1 grey" [icon]="faKey"></fa-icon><span>({{vehicle.vehicleRentalNumber}})</span>
                  </div> -->
                    </div>
                </div>

                <div class="vehicle-features">
                  <div class="row">
                    <div class="col-lg-8 col-md-12">
                      <div class="row mt-2">
                        <!-- vehicle Gear Type-->
                        <div class="col-lg-3 col-md-4 col-6 d-flex  align-items-top">
                          <span> <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' /></span>
                          <div>
                              <ul class="vehicle-inner-list">
                                <li>{{vehicle.vehicleGearType}}</li>
                            </ul>
                          </div>
                        </div>

                        <!-- vehicle Condition Unit -->
                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <span><mat-icon placement="bottom" ngbPopover="{{ 'ACUnit' | translate }}" triggers="mouseenter:mouseleave" class="fa-s  mr-1">ac_unit</mat-icon></span>
                          <div>
                              <ul  class="vehicle-inner-list">
                                <li>{{vehicle.hasAirConditions?'Yes':'No'}}</li>
                            </ul>
                          </div>
                        </div>

                        <!-- vehicle Petrol Type -->
                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <span><fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'FuelType' | translate }}" triggers="mouseenter:mouseleave"  [icon]="faGasPump"></fa-icon></span>
                            <div>
                                <ul  class="vehicle-inner-list">
                                  <li>{{vehicle.vehiclePetrolType}}</li>
                              </ul>
                            </div>
                        </div>

                        <!-- vehicle Passengers Number -->
                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <span> <fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'PassengersNum' | translate }}" triggers="mouseenter:mouseleave" [icon]="faUser"></fa-icon></span>
                          <div>
                              <ul  class="vehicle-inner-list">
                                <li>{{vehicle.vehiclePassengersNumber}}</li>
                            </ul>
                          </div>
                        </div>

                        <!-- vehicle Doors Number -->
                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <span><img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' /> </span>
                          <div>
                              <ul  class="vehicle-inner-list">
                                <li>{{vehicle.vehicleDoorsNumber}}</li>
                            </ul>
                          </div>
                        </div>

                        <!-- vehicle Storage -->
                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <span><mat-icon placement="bottom" ngbPopover="{{ 'Luggage' | translate }}" triggers="mouseenter:mouseleave" class="fa-s luggage mr-1">luggage</mat-icon></span>
                          <div>
                              <ul  class="vehicle-inner-list">
                                <li>{{vehicle.vehicleStorage}}</li>
                            </ul>
                          </div>
                        </div>

                        <!-- vehicle Number -->
                        <div class="col-lg-3 col-md-4  col-6 d-flex align-items-top">
                          <span><fa-icon  placement="bottom" class="mr-1" ngbPopover="{{ 'PlateNumber' | translate }}" triggers="mouseenter:mouseleave" [icon]="faCar"></fa-icon></span>
                          <div>
                              <ul  class="vehicle-inner-list">
                                <li>{{vehicle.vehiclePlateNumber}}</li>
                            </ul>
                          </div>
                        </div>

                        <!-- vehicle Odometer -->
                        <div class="col-lg-3 col-md-4  col-6 d-flex align-items-top">
                          <span><fa-icon placement="bottom" ngbPopover="{{ 'Odometer' | translate }}" triggers="mouseenter:mouseleave" class="mr-1" [icon]="faRoad"></fa-icon></span>
                          <div>
                              <ul  class="vehicle-inner-list">
                                <li>{{vehicle.vehicleOdometer}}</li>
                            </ul>
                          </div>
                        </div>

                        <div class="col-lg-3 col-md-4 col-6 d-flex align-items-top">
                          <div class="car-colors d-flex justify-content-center">
                            <ul>
                              <li class="d-inline" *ngFor="let color of vehicle.vehicleColors">
                                <div class="color-box mr-1" [style.backgroundColor]="color" ></div>
                              </li>
                            </ul>
                          </div>
                        </div>

                      </div>
                      <div class="row mb-2 mt-2">
                        <div class="col-md-12 d-flex align-items-top"><fa-icon class="mr-1 fa-s" [icon]="faMapMarkerAlt"></fa-icon>{{ 'From:' | translate }}  {{vehicle.agencyName | translate}} - {{ 'To:' | translate }}  {{vehicle.vehicleLocation | translate}}</div>
                        <div class="col-md-12"><div class="veheicle-status-confirmed">{{vehicle.vehicleBookingStatus}}</div></div>
                      </div>
                      <policies-icons [policyRequestModel]="vehicle"></policies-icons>
                    </div>
                    <div class="col-lg-4 col-md-12 pr-lg-0" *ngIf="vehicle.showCountDown">
                      <div   class="countdown wow pulse animated" *ngIf="!vehicle.late">
                        <div  class="countdown-title">{{ 'YourTripStartsIn' | translate }}</div>
                        <p [id]="'countdown_'+vehicle.caseID">
                          <span class="days" [id]="vehicle.caseID+'_days'"></span> <span class="time-sep"> : </span>
                          <span class="hours" [id]="vehicle.caseID+'_hours'"></span> <span class="time-sep"> : </span>
                          <span class="minutes" [id]="vehicle.caseID+'_minutes'"> </span> <span class="time-sep"> : </span>
                          <span class="seconds" [id]="vehicle.caseID+'_seconds'"></span>
                        </p>
                      </div>
                      <div *ngIf="vehicle.late">
                        <div   class="countdown wow pulse animated">
                          <div class="countdown-title"> {{ 'YouareLate' | translate }}</div>
                          <div class="late-duration">{{vehicle.startDateString}} {{vehicle.startTimeString}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-3 d-flex align-items-center justify-content-center">

                <div class="justify-content-center">
                  <div class="price-container">
                      <div class="duration">{{ 'PriceFor' | translate }} {{vehicle.durationUnitName}}</div>
                    <div class="vehicle-price">{{vehicle.vehiclePrice | number : '1.2-2'}} {{currency}}</div>
                  </div>
                  <div class="payable-now">
                    {{ 'OutstandingBalance' | translate }}
                    <!-- <span class="">{{vehicle.grandTotal - math.abs(vehicle.outStandingBalance) | number : '1.2-2'}} {{currency}}</span> -->
                    <span class="">{{vehicle.outStandingBalance | number : '1.2-2'}} {{currency}}</span>
                  </div>
                  <div class="book-now">
                    <button (click)="viewBooking(vehicle)" class="btn btn-book-now" mat-button>{{vehicle.vehicleBookingNumber}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- vehicle -->

        </div>
        <!-- End Card  -->
      </div>


      <div *ngIf="myBookingsFilter!=null && myBookingsFilter.length == 0">
        <div class="row">
          <div class="col-md-12 d-flex flex-column justify-content-center align-items-center">
            <div class="no-available-image">
              <!-- <mat-icon svgIcon="noAvailableRental"></mat-icon> -->
              <img src='assets/img/icons/car-noavailable.svg' />
            </div>
            <div class="no-available-text">
              <p>{{ 'NoBookedRentalYet' | translate }}</p>
            </div>
            <div class="no-available-btn">
              <a href="/" class="btn btn-book-now mat-button">{{ 'SearchForRentals' | translate }}</a>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>

